import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import './empty.styl'
class Empty extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        printable: PropTypes.bool
    }

    static defaultProps = {
        printable: true
    }


    render() {
        if(!this.props.printable) return ''
        let {className} = this.props;
        className = 'empty' + (className ? ' ' + className : '')

        return <div className={className} >
            <FormattedMessage id='app.empty'/>
        </div>
    }
}

export default Empty;